export default __webpack_public_path__ + "static/media/Battlefield_background-min.644e34c4.png";